import { deleteAlert } from './API';

const DeleteAlert = async (coin, subAccount, alertId, accessToken)  => {
  try {
    const response = await deleteAlert(coin, subAccount, alertId, accessToken);
    return { success: true, data: response.data };
  } catch (error) {    
    return { success: false, data: error.response.data.message };
  }
};

export default DeleteAlert;
